var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 4